import {hitAlgolytics} from "@pg-mono/algolytics";

type RatingType = "like" | "dislike" | null;

/**
 * Track when a user rates a property in a conversational search response
 * @param propertyId - The ID of the property being rated
 * @param rating - The rating given by the user (like, dislike, or null to remove rating)
 * @param apiMessageIndex - The index of the API_RESPONSE message (counts only API responses, not user messages)
 */
export const conversationalSearchResponseRatedHit = (propertyId: number, rating: RatingType, apiMessageIndex: number) => {
    hitAlgolytics("conversational_search_response_rated", {
        property_id: propertyId,
        rating,
        api_message_index: apiMessageIndex
    });
};
import {hitAlgolytics} from "@pg-mono/algolytics";

type RatingType = "like" | "dislike" | null;

/**
 * Track when a user rates a property in a conversational search response
 * @param propertyId - The ID of the property being rated
 * @param rating - The rating given by the user (like, dislike, or null to remove rating)
 * @param apiMessageIndex - The index of the API_RESPONSE message (counts only API responses, not user messages)
 */
export const conversationalSearchResponseRatedHit = (propertyId: number, rating: RatingType, apiMessageIndex: number) => {
    hitAlgolytics("conversational_search_response_rated", {
        property_id: propertyId,
        rating,
        api_message_index: apiMessageIndex
    });
};
